var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 14,
    viewBox: "0 0 2 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.989967 0C1.27635 0 1.51066 0.0846113 1.6929 0.253834C1.87514 0.423058 1.96626 0.650859 1.96626 0.937238C1.96626 1.23663 1.87514 1.47094 1.6929 1.64017C1.51066 1.80939 1.27635 1.894 0.989967 1.894C0.703589 1.894 0.469279 1.80939 0.287039 1.64017C0.117815 1.47094 0.0332031 1.23663 0.0332031 0.937238C0.0332031 0.637842 0.117815 0.410041 0.287039 0.253834C0.469279 0.0846113 0.703589 0 0.989967 0ZM0.345616 3.7099H1.63432V14H0.345616V3.7099Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.c08cb9a2b6da79ed386853854dc5c09a.svg";
export { ForwardRef as ReactComponent };